import type { ReactNode } from "react";
import { useWishlistStore } from "../store/wishlistStore";

export { useWishlistStore };

export const useWishlistContext = () => {
  const { wishlistedIds, isLoading, refreshWishlist } = useWishlistStore();
  return { wishlistedIds, isLoading, refreshWishlist };
};

/** Passthrough — wishlist state lives in Zustand, no provider needed. */
export const WishlistProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => <>{children}</>;
